import makeStyles from "@mui/styles/makeStyles";
import { dp } from "ds_legacy/materials/metrics";

export const DIALOG_MIN_HEIGHT = 285;
export const DIALOG_MAX_WIDTH = 800;

export const useDialogStyles = (
  {
    size,
  }: {
    size: "medium" | "small";
  } = { size: "small" },
) =>
  makeStyles(() => ({
    dialog: {
      minHeight: DIALOG_MIN_HEIGHT,
      ...(size === "medium"
        ? {
            maxWidth: dp(DIALOG_MAX_WIDTH),
            width: "100%",
          }
        : {}),
    },
    dialogContent: {
      boxSizing: "border-box",
      width: "100%",
    },
  }))();
